import script from "./BloqueDatos.vue?vue&type=script&setup=true&lang=ts"
export * from "./BloqueDatos.vue?vue&type=script&setup=true&lang=ts"

import "./BloqueDatos.vue?vue&type=style&index=0&id=4f5fbe0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5fbe0e"]])

export default __exports__